<script lang="ts">
	import { FilterStores } from "../../../../types/types.serpPage";

	export let filter: FilterStores;
</script>

checkboxSingle: {filter.name}
